import React, { useState, Fragment, useEffect } from 'react';
import cn from 'classnames';
import * as PropTypes from 'prop-types';

import TextInput from '../../../TextInput';
import ErrorBlock from '../../../common/ErrorBlock';
import loginValidator from '../../../../utils/validations/loginValidator';
import { isEmail } from '../../../../utils/validations/isEmail';

import styles from './styles.styl';

const InviteGuestInput = ({ formatMessage, item, onChange, onError }) => {
  const [emailOrPhoneError, setEmailOrPhoneError] = useState('');

  const isValidEmailOrPhone = val => {
    const isValid = val ? loginValidator(val) : true;
    if (!isValid) {
      const errorId = isEmail(val)
        ? 'errors.validation.invalidLoginEmail'
        : 'errors.validation.invalidLoginPhone';
      setEmailOrPhoneError(formatMessage({ id: errorId }));
    }
  };

  const resetEmailOrPhoneError = () => {
    if (emailOrPhoneError) setEmailOrPhoneError('');
  };

  useEffect(() => {
    onError(Boolean(emailOrPhoneError));
  }, [emailOrPhoneError]);

  return (
    <Fragment>
      <TextInput
        placeholder={formatMessage({
          id: 'fields.emailPhoneNumber',
        })}
        label={formatMessage({ id: 'fields.emailPhoneNumber' })}
        type="text"
        name="email"
        value={item.email}
        onBlur={val => isValidEmailOrPhone(val)}
        onFocus={resetEmailOrPhoneError}
        onChange={ev => onChange(ev, item.id)}
      />
      <If condition={Boolean(emailOrPhoneError)}>
        <ErrorBlock
          errors={emailOrPhoneError}
          className={cn(styles.errorBlock, 'mt3 mb3')}
        />
      </If>
    </Fragment>
  );
};

InviteGuestInput.propTypes = {
  item: PropTypes.object,
  onChange: PropTypes.func,
  formatMessage: PropTypes.func,
  onError: PropTypes.func,
};

export default InviteGuestInput;



// WEBPACK FOOTER //
// ./src/components/VirtualVideoRoom/Components/InviteGuestForm/InviteGuestInput.jsx